exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".divider__19DgI{border-top:1px solid rgba(34,36,38,.15);border-bottom:1px solid hsla(0,0%,100%,.1);margin:1rem 0;line-height:1;height:0;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:rgba(0,0,0,.85);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}", "", {"version":3,"sources":["/usr/src/app/src/components/Divider/Divider.scss"],"names":[],"mappings":"AAAA,gBACI,wCACA,2CACA,cACA,cACA,SACA,gBACA,yBACA,qBACA,sBACA,yBAAA,sBAAA,qBAAA,iBACA,uCAAwC,CAC3C","file":"Divider.scss","sourcesContent":[".divider {\n    border-top: 1px solid rgba(34, 36, 38, 0.15);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    margin: 1rem 0;\n    line-height: 1;\n    height: 0;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(0, 0, 0, 0.85);\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"divider": "divider__19DgI"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/Divider/Divider.scss
// module id = ZXUe
// module chunks = 0